export const formatUseYn = (value) => {
  if (value === 'Y') return '사용';
  if (value === 'N') return '미사용';
  return '-';
};
